import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { Alert, Button, Card, CardContent, CardHeader, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, FormLabel, Grid, IconButton, InputBase, InputLabel, List, ListItem, ListItemText, MenuItem, Paper, Radio, RadioGroup, Select, TextField, Typography } from '@mui/material';

import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

import { GrNext } from "react-icons/gr";

import PersonAddIcon from '@mui/icons-material/PersonAdd';
import SearchIcon from '@mui/icons-material/Search';

import moment from 'moment';

import { RootState } from '../../../store';
import { openSnackbar } from "../../../store/slices/SnackbarSlice";

import { DialogNuevaPersona } from '../../../dialogs/DialogNuevaPersona';
import { DialogBuscarAmparo } from '../../../dialogs/DialogBuscarAmparo';
import { DialogBuscarPersona } from '../../../dialogs/DialogBuscarPersona';

import { DialogContentStyle, DialogActionsStyle } from '../../../styles/DialogStyle';
import { InputSearchStyle, InputSearchButtonsStyle } from '../../../styles/FormStyle';

import { formatCurrency } from '../../../helpers/FormatCurrency';

import { defaultAmparo, defaultExhortoRecibido, defaultExpediente, setReducerRecepcion } from '../../../store/slices/RecepcionSlice';

import { ObtenerMateria } from '../../../connections/catalogos/MateriaConnection';
import { BuscarExpediente } from '../../../connections/comun/ExpedienteConnection';
import { BuscarExhortoRecibido } from '../../../connections/comun/ExhortoRecibidoConnection';
import { ObtenerTipoPromociones } from '../../../connections/catalogos/TipoPromocionConnection';
import { ObtenerAutoridadesMaterias } from '../../../connections/catalogos/AutoridadConnection';
import { ActualizarEstatus, RegistrarInformacion } from '../../../connections/comun/RecepcionConnection';
import { BuscarFolio, GenerarExhortoRecibido, GenerarExpediente } from '../../../connections/comun/FolioConnection';

import { AmparoProps } from '../../../interfaces/comun/AmparoInterface';
import { PresentanteProps } from '../../../interfaces/comun/PersonaInterface';
import { MateriaProps } from '../../../interfaces/catalogos/MateriaInterface';
import { ExpedienteProps } from '../../../interfaces/comun/ExpedienteInterface';
import { AutoridadProps } from '../../../interfaces/catalogos/AutoridadInterface';
import { defaultFolio, FolioProps } from '../../../interfaces/comun/FolioInterface';
import { TipoPromocionProps } from '../../../interfaces/catalogos/TipoPromocionInterface';
import { ExhortoRecibidoProps } from '../../../interfaces/comun/ExhortoRecibidoInterface';
import { RegistrarInformacionParams } from '../../../interfaces/comun/RecepcionInterface';

interface Props {
    numeroSeguimiento:      number;
    handleNext:             () => void;
}

export const RegistrarInformacionPage = ( { numeroSeguimiento, handleNext } : Props ) => {    

    const dispatch = useDispatch();

    const recepcion = useSelector( ( state: RootState ) => state.recepcion );

    const DateNow = moment( new Date()).format("YYYY-MM-DDTHH:mm");

    const [openGenerarExpediente, setOpenGenerarExpediente] = useState( false );

    const [presentante, setPresentante] = useState<PresentanteProps>( { idPersona: 0, nombreCompleto: '' } );    

    const [materia, setMateria] = useState( 0 );
    const [materiaTemp, setMateriaTemp] = useState( 0 );
    const [materiaArray, setMateriaArray] = useState<MateriaProps[]>( [] );

    const [tipoPromocion, setTipoPromocion] = useState( 0 );
    const [tipoPromocionTemp, setTipoPromocionTemp] = useState( 0 );
    const [tipoPromocionArray, setTipoPromocionArray] = useState<TipoPromocionProps[]>( [] );

    const [autoridad, setAutoridad] = useState( 0 );
    const [autoridadTemp, setAutoridadTemp] = useState( 0 );
    const [autoridadArray, setAutoridadArray] = useState<AutoridadProps[]>( [] );
    const [autoridadAllArray, setAutoridadAllArray] = useState<AutoridadProps[]>( [] );

    const [fechaReloj, setFechaReloj] = useState( DateNow );
    const [recibidoReloj, setRecibidoReloj] = useState( false );   

    const [loadingNext, setLoadingNext] = useState( false );
    const [loadingSave, setLoadingSave] = useState( false );
    const [loadingSearch, setLoadingSearch] = useState( false );
    const [loadingGenerate, setLoadingGenerate] = useState( false );

    const [recibidoPaqueteria, setRecibidoPaqueteria] = useState( false );

    const [referencia, setReferencia] = useState( '' );

    const [openDialogNuevaPersona, setopenDialogNuevaPersona] = useState(false);    
    const [openDialogBuscarPersona, setopenDialogBuscarPersona] = useState(false);
    const [openDialogBuscarAmparo, setopenDialogBuscarAmparo] = useState(false);

    const [expediente, setExpediente] = useState<ExpedienteProps>( defaultExpediente );
    const [exhortoRecibido, setExhortoRecibido] = useState<ExhortoRecibidoProps>( defaultExhortoRecibido );
    const [amparo, setAmparo] = useState<AmparoProps>( defaultAmparo );

    const [folio, setFolio] = useState<FolioProps>( defaultFolio );

    const [numeroAmparoOrigen, setNumeroAmparoOrigen] = useState('');

    const { idPersona, nombreCompleto } = presentante;

    const seleccionarPersona = ( persona: PresentanteProps ) => setPresentante( persona )    

    const seleccionarAmparo = ( amparo: AmparoProps ) => { setNumeroAmparoOrigen( amparo.numeroAmparoOrigen ?? '' ); setAmparo( amparo ); }

    const validateFiels = () => {

        let valid = true;
        
        if( idPersona === 0 && !recibidoPaqueteria ){
            valid = false;
            dispatch( openSnackbar({ message: 'Debes seleccionar un presentante', variant: 'warning' }));  
        }
        
        if( materia === 0 ){
            valid = false;
            dispatch( openSnackbar({ message: 'Debes seleccionar la materia', variant: 'warning' }));  
        }
        
        if( tipoPromocion === 0 ){
            valid = false;
            dispatch( openSnackbar({ message: 'Debes seleccionar un tipo de promoción', variant: 'warning' }));  
        }

        if( autoridad === 0 ){
            valid = false;
            dispatch( openSnackbar({ message: 'Debes seleccionar una autoridad', variant: 'warning' }));  
        }
        
        if( fechaReloj === '' && recibidoReloj ){
            valid = false;
            dispatch( openSnackbar({ message: 'Debes seleccionar la fecha de reloj', variant: 'warning' }));  
        }
        else if( moment( new Date( fechaReloj ) ) > moment( new Date( ) ) && recibidoReloj ){
            valid = false;
            dispatch( openSnackbar({ message: 'La fecha de reloj no puede ser mayor a la fecha actual', variant: 'warning' }));  
        }
        
        if( tipoPromocion === 1 && expediente.idExpediente === 0 ){
            valid = false;
            dispatch( openSnackbar({ message: 'Debes buscar el expediente para poder continuar', variant: 'warning' }));  
        }
        
        if( tipoPromocion === 4 && amparo.idAmparo === 0 ){
            valid = false;
            dispatch( openSnackbar({ message: 'Debes buscar el amparo para poder continuar', variant: 'warning' }));  
        }
        
        if( tipoPromocion === 5 && exhortoRecibido.idExhortoRecibido === 0 ){
            valid = false;
            dispatch( openSnackbar({ message: 'Debes buscar el exhorto para poder continuar', variant: 'warning' }));  
        }
        
        if( tipoPromocion === 7 && folio.idFolio === 0 ){
            valid = false;
            dispatch( openSnackbar({ message: 'Debes buscar el folio para poder continuar', variant: 'warning' }));  
        }
        
        if( amparo.idTipoAmparo === 1 && numeroAmparoOrigen === '' ){
            valid = false;
            dispatch( openSnackbar({ message: 'Debes escribir el número de amparo de origen', variant: 'warning' }));  
        }             

        return valid;
    } 

    const handleChangeMateria = ( value: number ) => {
        
        setExpediente( defaultExpediente );
        setExhortoRecibido( defaultExhortoRecibido );
        setAmparo( defaultAmparo ); 
        setFolio( defaultFolio );
        setReferencia( '' );
        setAutoridad( 0 );
        setTipoPromocion( 0 );
        
        setAutoridadTemp( 0 );
        setTipoPromocionTemp( 0 );

        setMateria( value );

    }

    const handleChangeTipoPromocion = ( value: number ) => {        
         
        setExpediente( defaultExpediente );
        setExhortoRecibido( defaultExhortoRecibido );
        setAmparo( defaultAmparo );
        setFolio( defaultFolio );
        setReferencia( '' );

        setAutoridad( 0 );
        setAutoridadTemp( 0 );

        setTipoPromocion( value );

    }
 
    const handleChangeAutoridad = ( value: number ) => {        
         
        setExpediente( defaultExpediente );
        setExhortoRecibido( defaultExhortoRecibido );
        setAmparo( defaultAmparo );
        setFolio( defaultFolio );
        setReferencia( '' );
        
        setAutoridad( value );

    } 

    const Guardar = async () => {

        const params: RegistrarInformacionParams = { 
            id: recepcion.id ?? '', 
            fechaReloj: recibidoReloj ? fechaReloj : '', 
            idMateria: materia, 
            idPresentante: idPersona, 
            recibidoPaqueteria: recibidoPaqueteria, 
            recibidoPorReloj: recibidoReloj,            
            idTipoPromocion: tipoPromocion,
            idAutoridad: autoridad,
            idExpediente: expediente.idExpediente,
            idExhortoRecibido: exhortoRecibido.idExhortoRecibido,
            idAmparo: amparo.idAmparo,
            numeroAmparoOrigen: numeroAmparoOrigen,
            idFolio: folio.idFolio,
        };

        const request = await RegistrarInformacion( params );  

        if( request.success ){

            const tipoPromocionDescripcion = tipoPromocionArray.find( (e) => e.idTipoPromocion === tipoPromocion )?.descripcion ?? '';
            const materiaDescripcion = materiaArray.find( (e) => e.idMateria === materia )?.descripcion ?? '';

            let autoridadDescripcion = '';
            let juzgadoOrigenDescripcion = '';
                
            const autoridadFind = autoridadAllArray.find( (e) => e.asignacion === true );

            if( autoridadFind ){
                autoridadDescripcion = autoridadFind?.descripcion ?? '';

                if( autoridadFind.idAutoridad !== autoridad ){
                    juzgadoOrigenDescripcion = autoridadAllArray.find( (e) => e.idAutoridad === autoridad )?.descripcion ?? '';
                }

            }

            dispatch( setReducerRecepcion({ 
                ...recepcion, 
                ...params, 
                tipoPromocion: tipoPromocionDescripcion, 
                materia: materiaDescripcion, 
                presentante: recibidoPaqueteria ? 'Enviado por paquetería' : nombreCompleto, 
                autoridad: autoridadDescripcion,
                juzgadoOrigen: juzgadoOrigenDescripcion,
                expediente: expediente,
                numeroExpediente: amparo.numeroExpediente ? amparo.numeroExpediente ?? '' : expediente.numeroExpediente ?? '',                
                exhortoRecibido: exhortoRecibido,
                numeroExhorto: exhortoRecibido.numeroExhorto ?? '',
                amparo:{ ...amparo, numeroAmparoOrigen: numeroAmparoOrigen, },
                numeroAmparo: amparo.numeroAmparo ?? '',
                tipoAmparo: amparo.tipoAmparo ?? '',
                autoridadAmparo: amparo.autoridadAmparo ?? '',
                autoridadExhorto: exhortoRecibido.autoridadExhorto ?? '',
                folio: folio,
                referencia: '',
            }));
        }

        return request;
    }

    const handleGuardar = async () => {

        const validFiels = validateFiels();

        if( !validFiels ){
            return false;
        }

        setLoadingSave( true );

        await Guardar().then( resp => {

            const { success, message } = resp;

            if( success ){

                setTimeout(() => {
                    
                    setLoadingSave( false );
                    dispatch( openSnackbar({ message: 'Se guardó la información correctamente', variant: 'success' }));   

                }, 700);
            }
            else {

                setTimeout(() => {
                    
                    dispatch( openSnackbar({ message: message, variant: 'warning' }));  

                    setLoadingSave( false );

                }, 700);

            }

        });       

    }

    const handleSiguiente = async () => {

        const validFiels = validateFiels();

        if( !validFiels ){
            return false;
        }

        setLoadingNext( true );

        if( !recepcion.acuseFirmado ){

            const { success: successGuardar, message: messageGuardar } = await Guardar();
    
            if( !successGuardar ){     

                setTimeout(() => {
                    
                    dispatch( openSnackbar({ message: messageGuardar, variant: 'error' }));  
                    
                    setLoadingNext( false );
    
                }, 700);

            }

        }

        await ActualizarEstatus({ id: recepcion.id ?? '', idEstatus: 6 }).then( resp => {

            const { success, message } = resp;

            if( success ){

                setTimeout(() => {
                    
                    setLoadingNext( false );
                    handleNext();

                }, 700);

            }
            else {

                setTimeout(() => {
                    
                    dispatch( openSnackbar({ message: message, variant: 'error' }));  
                    
                    setLoadingNext( false );

                }, 700);

            }

        });       

    }

    const handleBuscarExpediente = async () => {

        setLoadingSearch( true );

        await BuscarExpediente({ idAutoridad: autoridad, numeroExpediente: referencia }).then( resp => {

            const { success, message } = resp;

            if( success ){

                setTimeout(() => {
                    
                    setReferencia( '' );
                    setExpediente( resp );
                    setLoadingSearch( false );

                }, 700);

            }
            else {

                setTimeout(() => {
                    
                    dispatch( openSnackbar({ message: message, variant: 'error' }));  
                    
                    setReferencia( '' );
                    setExpediente( resp );
                    setLoadingSearch( false );

                }, 700);

            }

        });       

    }

    const handleBuscarExhortoRecibido = async () => {

        setLoadingSearch( true );

        await BuscarExhortoRecibido({ idAutoridad: autoridad, numeroExhorto: referencia }).then( resp => {

            const { success, message } = resp;

            if( success ){

                setTimeout(() => {
                    
                    setReferencia( '' );
                    setExhortoRecibido( resp );
                    setLoadingSearch( false );

                }, 700);

            }
            else {

                setTimeout(() => {
                    
                    dispatch( openSnackbar({ message: message, variant: 'error' }));  
                    
                    setReferencia( '' );
                    setExhortoRecibido( resp );
                    setLoadingSearch( false );

                }, 700);

            }

        });       

    }

    const handleBuscarFolio = async () => {

        setLoadingSearch( true );      
                
        await BuscarFolio({ numeroFolio: referencia, idAutoridad: autoridad }).then( resp => {

            const { success, message } = resp;

            if( success ){

                setTimeout(() => {
                    
                    setReferencia( '' );
                    setFolio( resp );
                    setLoadingSearch( false );

                }, 700);

            }
            else {

                setTimeout(() => {
                    
                    dispatch( openSnackbar({ message: message, variant: 'error' }));  
                    
                    setReferencia( '' );
                    setFolio( defaultFolio );
                    setLoadingSearch( false );

                }, 700);

            }

            
        });

    }   

    const handleBuscar = async () => {

        setExpediente( defaultExpediente );
        setExhortoRecibido( defaultExhortoRecibido );
        setFolio( defaultFolio );
        setReferencia( '' );
        
        if( tipoPromocion === 1 ){
            setAmparo( defaultAmparo );
            
            await handleBuscarExpediente();
        }
        else if( tipoPromocion === 4 ){
            setopenDialogBuscarAmparo( true );
        }
        else if( tipoPromocion === 5 ){
            setAmparo( defaultAmparo );
            
            handleBuscarExhortoRecibido();
        }
        else if( tipoPromocion === 7 ){
            setAmparo( defaultAmparo );
            
            await handleBuscarFolio();
        }

    }

    const handleOpenGenerarExpediente = () => {
        
        const validFiels = validateFiels();

        if( !validFiels ){
            return false;
        }

        setOpenGenerarExpediente( true );
    }

    const handleGenerarExpediente = async () => {

        setLoadingGenerate( true );

        if( folio.esExhorto ){

            await GenerarExhortoRecibido({ idAutoridad: autoridad, idFolio: folio.idFolio, }).then( resp => {

                const { success, message } = resp;

                if( success ){

                    setTimeout(() => {
                        
                        setFolio({ ...resp });
                        setLoadingGenerate( false );
                        setOpenGenerarExpediente( false );

                    }, 700);

                }
                else {

                    setTimeout(() => {
                        
                        dispatch( openSnackbar({ message: message, variant: 'error' }));                          
                        setLoadingGenerate( false );
                        setOpenGenerarExpediente( false );

                    }, 700);

                }

            });  

        }
        else if( !folio.esExhorto ){

            await GenerarExpediente({ idAutoridad: autoridad, idFolio: folio.idFolio, }).then( resp => {

                const { success, message } = resp;

                if( success ){

                    setTimeout(() => {
                        
                        setFolio({ ...resp });
                        setLoadingGenerate( false );
                        setOpenGenerarExpediente( false );

                    }, 700);

                }
                else {

                    setTimeout(() => {
                        
                        dispatch( openSnackbar({ message: message, variant: 'error' }));                          
                        setLoadingGenerate( false );
                        setOpenGenerarExpediente( false );

                    }, 700);

                }

            });  

        }    

    }

    useEffect(() => {
        
        async function Obtener(){
            
            await ObtenerMateria().then( resp => {  
                setMateriaArray( resp );    
            });

        }

        Obtener();

    }, [ ]);
    
    useEffect(() => {
        
        if( materiaArray.length !== 0 && materiaTemp !== 0 ){
            setMateria( materiaTemp );
        }

    }, [ materiaArray, materiaTemp ]);

    useEffect(() => {
   
        async function Obtener(){
   
            setTipoPromocion( 0 );
            setTipoPromocionArray( [] );           

            await ObtenerTipoPromociones().then( resp => {  

                setTipoPromocionArray( resp );

                if( tipoPromocionTemp !== 0 ){
            
                    const existe = resp.find( e => e.idTipoPromocion === tipoPromocionTemp );
            
                    if( existe ) setTipoPromocion( tipoPromocionTemp );
            
                }

            }); 

        }

        Obtener();

    }, [ tipoPromocionTemp ]);

    useEffect(() => {

        async function Obtener(){

            setAutoridad( 0 );
            setAutoridadArray( [] );           

            if( materia !== 0 ){

                await ObtenerAutoridadesMaterias( materia ).then( resp => {  

                    setAutoridadArray( resp );
                    setAutoridadAllArray( resp );

                    if( autoridadTemp !== 0 ){

                        const existe = resp.find( e => e.idAutoridad === autoridadTemp );
                        
                        if( existe ) setAutoridad( autoridadTemp );

                    }

                });                   
            }
        }
        
        Obtener();

    }, [ materia, autoridadTemp ]);

    useEffect(() => {
        
        if( recepcion.id ){

            setReferencia( recepcion.referencia ?? '' );
            setRecibidoPaqueteria( recepcion.recibidoPaqueteria ?? false );
            setRecibidoReloj( recepcion.recibidoPorReloj ?? false );
            setFechaReloj( recepcion.fechaReloj ?? '' );

            setPresentante( { idPersona: recepcion.idPresentante ?? 0, nombreCompleto: recepcion.presentante ?? '', } );

            setMateriaTemp( recepcion.idMateria ?? 0 );
            setTipoPromocionTemp( recepcion.idTipoPromocion ?? 0 );
            setAutoridadTemp( recepcion.idAutoridad ?? 0 );

            setExpediente( recepcion.expediente ?? defaultExpediente );
            setExhortoRecibido( recepcion.exhortoRecibido ?? defaultExhortoRecibido );
            setAmparo( recepcion.amparo ?? defaultAmparo );
            setNumeroAmparoOrigen( recepcion.amparo?.numeroAmparoOrigen ?? '' );
            setFolio( recepcion.folio ?? defaultFolio );
        }

    }, [ recepcion ]);
       
    return (
        <>
            <Grid container spacing={3}>    

                <Grid size={{ md: 12, xs: 12 }}>       

                    <Card sx={{ mt: 2 }}>
                    
                        <CardHeader 
                            sx={{ backgroundColor: (theme) => theme.palette.primary.main }} 
                            subheader={ 
                                <Grid container spacing={3}>

                                    <Grid size={{ md: 6, xs: 6 }}>                                                                    
                                        <Typography variant='h6' sx={{ color: 'white' }}> Registrar información </Typography> 
                                    </Grid>
                                
                                    <Grid size={{ md: 6, xs: 6 }} sx={{ textAlign: 'end' }}>
                                        <Chip variant='filled' sx={{ bgcolor: 'white', borderRadius: 2, p: 2 }} label={ <Typography variant='h6'> RT-{ numeroSeguimiento } </Typography>  } />
                                    </Grid>

                                </Grid>
                            }
                        />
                    
                        <CardContent sx={{ p: 3 }}>
                        
                            <Grid container spacing={3}>   
                                
                                {
                                    ( !recepcion.provieneBuzonElectronico )
                                    &&
                                        <Grid size={{ md: !recibidoPaqueteria ? 4 : 12, xs: 12 }}>

                                            <FormControl disabled={ recepcion.acuseFirmado !== '' }>

                                                <FormLabel>¿El trámite es recibido por paquetería?</FormLabel>
                                                <RadioGroup row>
                                                    <FormControlLabel control={ <Radio checked={ recibidoPaqueteria === false } onChange={ ( e ) => { setRecibidoPaqueteria( false ); setPresentante({ idPersona: 0, nombreCompleto: '' }); } } />} label="No" />
                                                    <FormControlLabel control={ <Radio checked={ recibidoPaqueteria === true } onChange={  ( e ) => { setRecibidoPaqueteria( true); setPresentante({ idPersona: 0, nombreCompleto: '' }); } } />} label="Si" />
                                                </RadioGroup>

                                            </FormControl>

                                        </Grid>
                                }  

                                {
                                    !recibidoPaqueteria
                                    &&
                                        <Grid size={{ md: 8, xs: 12 }} > 

                                            {
                                                ( !recepcion.acuseFirmado && !recepcion.provieneBuzonElectronico )
                                                ?
                                                    <Paper component="div" sx={ InputSearchStyle } >    

                                                        <InputBase 
                                                            sx={{ ml: 1, flex: 1 }} 
                                                            inputProps={{ 'aria-label': 'Buscar presentante' }} 
                                                            placeholder="Buscar presentante"   
                                                            value={ nombreCompleto }   
                                                            onChange={ () => {} }             
                                                            autoComplete="off"   
                                                            disabled
                                                        /> 
                                                    
                                                        <Button 
                                                            size='small'
                                                            variant='contained' 
                                                            sx={ InputSearchButtonsStyle } 
                                                            disabled={ recibidoPaqueteria }
                                                            onClick={ () => setopenDialogBuscarPersona( true ) }
                                                        >
                                                            <SearchIcon />
                                                        </Button>     
                                                            
                                                        <Button 
                                                            variant='contained' 
                                                            size='small'
                                                            sx={ InputSearchButtonsStyle } 
                                                            disabled={ recibidoPaqueteria }
                                                            onClick={ () => setopenDialogNuevaPersona( true ) }
                                                        >
                                                            <PersonAddIcon />
                                                        </Button>     

                                                    </Paper> 
                                                :
                                                    <>
                                                        <Typography variant='subtitle2' color='textSecondary'>Presentante:</Typography>
                                                        <Typography variant='subtitle2' color='textSecondary'>{ nombreCompleto }</Typography>                                                    
                                                    </>
                                            }

                                        </Grid>                      
                                }   
                                
                                {
                                    ( !recepcion.provieneBuzonElectronico )
                                    &&
                                        <Grid size={{ md: 6, xs: 12 }}>                            

                                            <FormControl disabled={ recepcion.acuseFirmado !== '' }>
                                                
                                                <FormLabel>¿El trámite es recibido por reloj?</FormLabel>
                                                <RadioGroup row>
                                                    <FormControlLabel control={ <Radio checked={ recibidoReloj === true } onChange={ () => { setRecibidoReloj( true ); setFechaReloj( DateNow ); }} />} label="Si" />                        
                                                    <FormControlLabel control={ <Radio checked={ recibidoReloj === false } onChange={ () => setRecibidoReloj( false ) } />} label="No" />    
                                                </RadioGroup>

                                            </FormControl>

                                        </Grid>
                                }

                                {
                                    ( !recepcion.provieneBuzonElectronico )
                                    &&
                                        <Grid size={{ md: 6, xs: 12 }}>                            

                                            {
                                                recibidoReloj 
                                                && 
                                                <LocalizationProvider dateAdapter={ AdapterMoment } adapterLocale="es"> 

                                                        <DateTimePicker                                        
                                                            label="Fecha de recepción por reloj"       
                                                            sx={{ width: '100%' }}  
                                                            disabled={ recepcion.acuseFirmado !== '' }
                                                            value={ moment( fechaReloj ) }
                                                            maxDate={ moment( new Date() ) }
                                                            onChange={ (e) => setFechaReloj( moment( e ).format( 'YYYY-MM-DDTHH:mm' ) ) }
                                                        />        

                                                    </LocalizationProvider>                                             
                                            }

                                        </Grid>                         
                                }

                                <Grid size={{ md: 12, xs: 12 }}>  

                                    <FormControl disabled={ recepcion.acuseFirmado !== '' || recepcion.provieneBuzonElectronico }>

                                        <FormLabel>Seleccione la materia</FormLabel>
                                        <RadioGroup row>
                                            {
                                                materiaArray
                                                .map( ({ idMateria, descripcion }) => (
                                                    <FormControlLabel 
                                                        key={ idMateria }
                                                        label={ descripcion }
                                                        control={ <Radio checked={ materia === idMateria } 
                                                        onChange={ () => handleChangeMateria( idMateria ) } />} 
                                                    />                        
                                                ))
                                            }                                      
                                        </RadioGroup>

                                    </FormControl>

                                </Grid>                                        

                                <Grid size={{ md: 6, xs: 12 }}>                            
                                
                                    <FormControl fullWidth>
                                        <InputLabel>Tipo de promoción</InputLabel>
                                    
                                        <Select                                         
                                            label="Tipo de promoción"
                                            value={ tipoPromocion }
                                            onChange={ (e) => handleChangeTipoPromocion( e.target.value )  }
                                            disabled={ recepcion.acuseFirmado !== '' || materia === 0 || recepcion.provieneBuzonElectronico }
                                        >
                                            <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>   
                                            {
                                                materia === 1
                                                ?
                                                    tipoPromocionArray
                                                    .filter( ({ idTipoPromocion }) => idTipoPromocion !== 7 )                                                
                                                    .map( ({ idTipoPromocion, descripcion  }) => (
                                                        <MenuItem key={idTipoPromocion} value={idTipoPromocion}>{ descripcion }</MenuItem>   
                                                    ))
                                                :
                                                    tipoPromocionArray                                             
                                                    .map( ({ idTipoPromocion, descripcion  }) => (
                                                        <MenuItem key={idTipoPromocion} value={idTipoPromocion}>{ descripcion }</MenuItem>   
                                                    ))
                                            }
                                        </Select>

                                    </FormControl>
                                
                                </Grid> 

                                <Grid size={{ md: 6, xs: 12 }}>                            
                            
                                    <FormControl fullWidth>
                                        <InputLabel>Autoridad</InputLabel>
                                    
                                        <Select                                                                            
                                            label="Autoridad"
                                            value={ autoridad }
                                            onChange={ (e) => handleChangeAutoridad( e.target.value )  }
                                            disabled={ recepcion.acuseFirmado !== '' || materia === 0 || recepcion.provieneBuzonElectronico || tipoPromocion === 0 }
                                        >
                                            <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>   
                                            {
                                                tipoPromocion === 7
                                                ?
                                                    autoridadArray
                                                    .filter( (e) => e.asignacion !== true)
                                                    .map( ({ idAutoridad, descripcion }) => (
                                                        <MenuItem key={idAutoridad} value={idAutoridad}>{ descripcion }</MenuItem>   
                                                    ))
                                                :
                                                    autoridadArray
                                                    .map( ({ idAutoridad, descripcion }) => (
                                                        <MenuItem key={idAutoridad} value={idAutoridad}>{ descripcion }</MenuItem>   
                                                    ))
                                            }                                            
                                        </Select>

                                    </FormControl>
                                
                                </Grid> 

                                {
                                    (( recepcion.acuseFirmado === '' && !recepcion.provieneBuzonElectronico ) || ( recepcion.acuseFirmado === '' && (  expediente.idExpediente === 0 || exhortoRecibido.idExhortoRecibido === 0 ) && recepcion.provieneBuzonElectronico ) )
                                    &&
                                        <Grid size={{ md: 12, xs: 12 }}> 
                            
                                            <Paper component="div" sx={ InputSearchStyle }>                            
                                                
                                                <InputBase 
                                                    sx={{ ml: 1, flex: 1 }} 
                                                    placeholder={
                                                        tipoPromocion === 1
                                                        ? "Buscar por número de expediente" :
                                                        tipoPromocion === 4
                                                        ? "Buscar amparo por número auxiliar, número de origen, número de expediente" :
                                                        tipoPromocion === 5
                                                        ? "Buscar por número de exhorto" :
                                                        tipoPromocion === 7
                                                        ? "Buscar por número de folio" 
                                                        : 'Buscar por número'
                                                    } 
                                                    name="expediente"                                     
                                                    autoComplete="off"
                                                    disabled={ autoridad === 0 || tipoPromocion === 4 }
                                                    value={ referencia }
                                                    onChange={ (e) => setReferencia( e.target.value ) }
                                                /> 

                                                <Button 
                                                    variant='contained' 
                                                    size='small'
                                                    sx={ InputSearchButtonsStyle } 
                                                    disabled={  
                                                        tipoPromocion === 4
                                                        ?
                                                            recepcion.acuseFirmado !== '' || autoridad === 0
                                                        :
                                                            recepcion.acuseFirmado !== '' || autoridad === 0 || referencia === '' 
                                                    }
                                                    loading={ loadingSearch }
                                                    onClick={ handleBuscar }
                                                >
                                                    <SearchIcon />
                                                </Button>   

                                            </Paper>

                                        </Grid>  
                                }

                                {
                                    expediente.idExpediente !== 0
                                    &&
                                        <Grid size={{ md: 12, xs: 12 }}>

                                            <Grid container spacing={3}>

                                                <Grid size={{ md: 6, xs: 12 }}>

                                                    <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de expediente: </Typography>
                                                    <Typography variant='subtitle2'> 
                                                        <strong>{ expediente.numeroExpediente }</strong> &nbsp;&nbsp; { expediente.numeroFolio && `(F. ${ expediente.numeroFolio })` }                                                    
                                                    </Typography>                                    

                                                </Grid>
                                           
                                                <Grid size={{ md: 6, xs: 12 }}>
                                                        
                                                    <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Tipo de juicio: </Typography> 
                                                    <Typography variant='subtitle2' fontWeight={'bold'}> { expediente.tipoJuicio } </Typography>                                                   

                                                </Grid>
                                                
                                                {
                                                    expediente.cuantia
                                                    &&
                                                        <Grid size={{ md: 6, xs: 12 }}>
                                                                
                                                            <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Cuantía: </Typography> 
                                                            <Typography variant='subtitle2' fontWeight={'bold'}> { formatCurrency( expediente.cuantia ) } </Typography>                                                   

                                                        </Grid>        
                                                }    

                                                {
                                                    expediente.actor.length !== 0
                                                    &&
                                                        <Grid size={{ md: 6, xs: 12 }}>
                                                            
                                                            <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Actor(es): </Typography> 
                                                            <Typography variant='subtitle2' fontWeight={'bold'}> { expediente.actor.join(', ') } </Typography> 

                                                        </Grid>
                                                }

                                                {
                                                    expediente.demandado.length !== 0
                                                    &&
                                                        <Grid size={{ md: 6, xs: 12 }}>

                                                            <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Demandado(s): </Typography> 
                                                            <Typography variant='subtitle2' fontWeight={'bold'}> { expediente.demandado.join(', ') } </Typography> 

                                                        </Grid>
                                                }

                                            </Grid>
                                        
                                        </Grid>
                                }

                                {
                                    exhortoRecibido.idExhortoRecibido !== 0
                                    &&
                                        <Grid size={{ md: 12, xs: 12 }}>

                                            <Grid container spacing={3}>

                                                <Grid size={{ md: 6, xs: 12 }}>

                                                    <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de exhorto: </Typography>
                                                    <Typography variant='subtitle2'> 
                                                        <strong>{ exhortoRecibido.numeroExhorto }</strong> &nbsp;&nbsp; { exhortoRecibido.numeroFolio && `(F. ${ exhortoRecibido.numeroFolio })` }                                                    
                                                    </Typography>                                            

                                                </Grid>

                                                {
                                                    exhortoRecibido.numeroExpedienteOrigen
                                                    &&
                                                        <Grid size={{ md: 6, xs: 12 }}>

                                                            <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de expediente de origen: </Typography>
                                                            <Typography variant='subtitle2' fontWeight={'bold'}> { exhortoRecibido.numeroExpedienteOrigen } </Typography>                                            

                                                        </Grid>
                                                }
                                           
                                                <Grid size={{ md: 6, xs: 12 }}>
                                                        
                                                    <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Tipo de juicio: </Typography> 
                                                    <Typography variant='subtitle2' fontWeight={'bold'}> { exhortoRecibido.tipoJuicio } </Typography>                                                   

                                                </Grid>
                                                
                                                {
                                                    exhortoRecibido.cuantia
                                                    &&
                                                        <Grid size={{ md: 6, xs: 12 }}>
                                                                
                                                            <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Cuantía: </Typography> 
                                                            <Typography variant='subtitle2' fontWeight={'bold'}> { formatCurrency( exhortoRecibido.cuantia ) } </Typography>                                                   

                                                        </Grid>        
                                                }    

                                                {
                                                    exhortoRecibido.autoridadExhorto
                                                    &&
                                                        <Grid size={{ md: 6, xs: 12 }}>
                                                                
                                                            <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Autoridad del exhorto: </Typography> 
                                                            <Typography variant='subtitle2' fontWeight={'bold'}> { exhortoRecibido.autoridadExhorto } </Typography>                                                   

                                                        </Grid>
                                                }

                                                {
                                                    exhortoRecibido.actor.length !== 0
                                                    &&
                                                        <Grid size={{ md: 6, xs: 12 }}>
                                                            
                                                            <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Actor(es): </Typography> 
                                                            <Typography variant='subtitle2' fontWeight={'bold'}> { exhortoRecibido.actor.join(', ') } </Typography> 

                                                        </Grid>
                                                }

                                                {
                                                    exhortoRecibido.demandado.length !== 0
                                                    &&
                                                        <Grid size={{ md: 6, xs: 12 }}>

                                                            <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Demandado(s): </Typography> 
                                                            <Typography variant='subtitle2' fontWeight={'bold'}> { exhortoRecibido.demandado.join(', ') } </Typography> 

                                                        </Grid>
                                                }

                                            </Grid>
                                        
                                        </Grid>
                                }

                                {
                                    amparo.idAmparo !== 0
                                    &&
                                        <Grid size={{ md: 12, xs: 12 }}>

                                            <Grid container spacing={3}>

                                                {
                                                    amparo.numeroAmparo
                                                    &&
                                                        <Grid size={{ md: 6, xs: 12 }}>

                                                            <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número auxiliar de amparo: </Typography>
                                                            <Typography variant='subtitle2' fontWeight={'bold'}> { amparo.numeroAmparo } </Typography>                                            

                                                        </Grid>
                                                }

                                                {
                                                    ( !amparo.numeroAmparo && amparo.numeroAmparoOrigen )
                                                    &&
                                                        <Grid size={{ md: 6, xs: 12 }}>

                                                            <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de amparo de origen: </Typography>
                                                            <Typography variant='subtitle2' fontWeight={'bold'}> { amparo.numeroAmparoOrigen } </Typography>                                            

                                                        </Grid>
                                                }

                                                {
                                                    ( amparo.numeroAmparoOrigen && amparo.idTipoAmparo !== 1 )
                                                    &&
                                                        <Grid size={{ md: 6, xs: 12 }}>

                                                            <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de origen del amparo: </Typography>
                                                            <Typography variant='subtitle2' fontWeight={'bold'}> { amparo.numeroAmparoOrigen } </Typography>                                            

                                                        </Grid>
                                                }    

                                                {
                                                    amparo.numeroExpediente
                                                    &&
                                                        <Grid size={{ md: 6, xs: 12 }}>

                                                            <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de expediente: </Typography>
                                                            <Typography variant='subtitle2' fontWeight={'bold'}> { amparo.numeroExpediente } </Typography>                                            

                                                        </Grid>
                                                }                           
                                           
                                                <Grid size={{ md: 6, xs: 12 }}>
                                                        
                                                    <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Tipo de amparo: </Typography> 
                                                    <Typography variant='subtitle2' fontWeight={'bold'}> { amparo.tipoAmparo } </Typography>                                                   

                                                </Grid>                                   
                                           
                                                <Grid size={{ md: 6, xs: 12 }}>
                                                        
                                                    <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Autoridad del amparo: </Typography> 
                                                    <Typography variant='subtitle2' fontWeight={'bold'}> { amparo.autoridadAmparo } </Typography>                                                   

                                                </Grid>         

                                                {
                                                    ( amparo.idTipoAmparo === 1 && amparo.numeroAmparo )
                                                    &&    
                                                        <Grid size={{ md: 6, xs: 12 }}>    
                                                            
                                                            <TextField                              
                                                                fullWidth       
                                                                label="Número de amparo de origen"
                                                                name="numeroAmparoOrigen"       
                                                                autoComplete='off'                      
                                                                value={ numeroAmparoOrigen }    
                                                                onChange={ ( e ) => { setNumeroAmparoOrigen( e.target.value ); } }                                                     
                                                                disabled={ recepcion.acuseFirmado !== '' }
                                                                slotProps={{
                                                                    input: {
                                                                        autoComplete: 'off'
                                                                    },
                                                                    inputLabel: {
                                                                        shrink: true,
                                                                    }
                                                                }}        
                                                            />

                                                        </Grid>
                                                }      

                                                {
                                                    amparo.partes.length !== 0
                                                    &&
                                                        <Grid size={{ md: 6, xs: 12 }}>
                                                            <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Partes: </Typography> 

                                                            <List disablePadding>
                                                                {                                                            
                                                                    amparo.partes.map( ({ persona, tipoParte }, index ) => (
                                                                        <ListItem key={ index } disableGutters>
                                                                            <ListItemText>
                                                                                <Typography variant='subtitle2'>{ persona }</Typography>
                                                                                <Typography variant='subtitle2' fontWeight={'bold'}>({ tipoParte })</Typography>
                                                                            </ListItemText>                                                                         
                                                                        </ListItem>
                                                                    ))
                                                                }
                                                            </List>                                       

                                                        </Grid>
                                                }                          

                                            </Grid>
                                        
                                        </Grid>
                                }

                                {
                                   
                                    folio.idFolio !== 0
                                    &&
                                        <Grid size={{ md: 12, xs: 12 }}>

                                            <Grid container spacing={3}>

                                                <Grid size={{ md: 6, xs: 12 }}>

                                                    <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de folio: </Typography>
                                                    <Typography variant='subtitle2' fontWeight={'bold'}> { folio.numeroFolio } </Typography>                                            

                                                </Grid>

                                                {
                                                    folio.numeroExpediente
                                                    &&
                                                        <Grid size={{ md: 6, xs: 12 }}>

                                                            <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de expediente: </Typography>
                                                            <Typography variant='subtitle2' fontWeight={'bold'}> { folio.numeroExpediente } </Typography>                                            

                                                        </Grid>
                                                }
                                             
                                                {
                                                    folio.numeroExhortoRecibido
                                                    &&
                                                        <Grid size={{ md: 6, xs: 12 }}>

                                                            <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de exhorto: </Typography>
                                                            <Typography variant='subtitle2' fontWeight={'bold'}> { folio.numeroExhortoRecibido } </Typography>                                            

                                                        </Grid>
                                                }
                                           
                                                <Grid size={{ md: 6, xs: 12 }}>
                                                        
                                                    <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Tipo de juicio: </Typography> 
                                                    <Typography variant='subtitle2' fontWeight={'bold'}> { folio.tipoJuicio } </Typography>                                                   

                                                </Grid>        

                                                {
                                                    folio.cuantia
                                                    &&
                                                        <Grid size={{ md: 6, xs: 12 }}>
                                                                
                                                            <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Cuantía: </Typography> 
                                                            <Typography variant='subtitle2' fontWeight={'bold'}> { formatCurrency( folio.cuantia ) } </Typography>                                                   

                                                        </Grid>        
                                                }                                    

                                                {
                                                    folio.partes.filter( (e) => e.idTipoParte === 1 ).length !== 0
                                                    &&
                                                        <Grid size={{ md: 6, xs: 12 }}>
                                                            
                                                            <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Actor(es): </Typography> 
                                                            <Typography variant='subtitle2' fontWeight={'bold'}> 
                                                                { folio.partes.filter( (e) => e.idTipoParte === 1 ).map( ({ persona }) => persona ).join(', ') } 
                                                            </Typography> 

                                                        </Grid>
                                                }                               
                                              
                                                {
                                                    folio.partes.filter( (e) => e.idTipoParte === 2 ).length !== 0
                                                    &&
                                                        <Grid size={{ md: 6, xs: 12 }}>
                                                            
                                                            <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Demandado(s): </Typography> 
                                                            <Typography variant='subtitle2' fontWeight={'bold'}> 
                                                                { folio.partes.filter( (e) => e.idTipoParte === 2 ).map( ({ persona }) => persona ).join(', ') } 
                                                            </Typography> 

                                                        </Grid>
                                                }    
                                                    
                                                {
                                                    folio.observaciones 
                                                    && 
                                                        <Grid size={12}>
                                                            <Alert severity="warning" variant="filled">
                                                                { folio.observaciones }
                                                            </Alert>
                                                        </Grid>
                                                }               

                                            </Grid>
                                        
                                        </Grid>
                                }
                                
                            </Grid> 

                        </CardContent>
                    
                    </Card>  
                
                </Grid>

                <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>  

                    <Grid container spacing={3}>

                        <Grid size={{ md: 4, xs: 12 }}>

                        </Grid>
                    
                        <Grid size={{ md: 4, xs: 12 }} sx={{ textAlign: 'center '}}>

                            {
                                ( !recepcion.acuseFirmado && !recepcion.provieneBuzonElectronico )
                                &&
                                    <Button 
                                        fullWidth
                                        variant="contained"                                      
                                        onClick={ handleGuardar }
                                        loading={ loadingSave }
                                    > 
                                        Guardar 
                                    </Button>
                            }

                        </Grid>
                    
                        <Grid size={{ md: 4, xs: 12 }} sx={{ textAlign: 'end '}}>

                            <IconButton     
                                color='primary'                     
                                loading={ loadingNext }
                                onClick={ () => folio.generarExpediente ? handleOpenGenerarExpediente() : handleSiguiente() }
                            > 
                                <GrNext />
                            </IconButton>

                        </Grid>

                    </Grid>              

                </Grid>
            
            </Grid> 

            <Dialog 
                maxWidth='sm'    
                fullWidth={true}
                disableEscapeKeyDown
                open={ openGenerarExpediente }
                onClose={ () => {} } 
            >
                
                <DialogTitle>
                    Confirmación
                </DialogTitle>
                
                <DialogContent sx={ DialogContentStyle }>
                
                    <DialogContentText>
                        ¿Desea asignar el numéro de { folio.esExhorto ? 'exhorto' : 'expediente' } para el folio <strong>{ folio.numeroFolio }</strong>?
                    </DialogContentText>
                
                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>

                    <Button color='secondary' disabled={ loadingGenerate } onClick={ () => setOpenGenerarExpediente( false ) }> Cancelar </Button>
                    <Button 
                        variant='contained'  
                        loading={ loadingGenerate }
                        onClick={ handleGenerarExpediente } 
                    > 
                        Aceptar 
                    </Button>
                    
                </DialogActions>

            </Dialog>

            <DialogNuevaPersona 
                openDialog={ openDialogNuevaPersona } 
                handleCloseDialog={ () => setopenDialogNuevaPersona( false ) } 
                seleccionarPersona={ seleccionarPersona }
            />

            <DialogBuscarPersona
                openDialog={ openDialogBuscarPersona } 
                handleCloseDialog={ () => setopenDialogBuscarPersona( false ) } 
                seleccionarPersona={ seleccionarPersona }
            /> 

            <DialogBuscarAmparo
                autoridad={ autoridad }
                openDialog={ openDialogBuscarAmparo } 
                handleCloseDialog={ () => setopenDialogBuscarAmparo( false ) } 
                seleccionarAmparo={ seleccionarAmparo }
            /> 
        
        </>        
    );
}
